import { useFieldClickTarget } from '../../hooks/useFieldClickTarget';
import { ErrorText } from '../ErrorText';
import { FieldLabel, FieldWrapper, RequiredMark } from './FormField.styles';
import type { FormFieldProps } from './FormField.types';

export function FormField({
  label,
  required,
  error,
  errorId,
  children,
  fullWidth,
}: FormFieldProps) {
  const { ref, onMouseDown, onClick } = useFieldClickTarget<HTMLDivElement>();

  return (
    <FieldWrapper ref={ref} onMouseDown={onMouseDown} onClick={onClick} $fullWidth={fullWidth}>
      <FieldLabel $error={Boolean(error)}>
        {label}
        {required && <RequiredMark>*</RequiredMark>}
      </FieldLabel>
      {children}
      {error && <ErrorText id={errorId}>{error}</ErrorText>}
    </FieldWrapper>
  );
}
